import { IconLinePlus } from "@kalodata/kds-design-icons";
import type { LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { TIKTOK_PLATFORM } from "@store/linkedAccountSlice";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useLinkAccount } from "../hooks/useLinkAccount";
import { Button } from "@kalodata/kds-design";

interface AddLinkedAccountButtonProps {
  platform: LinkedAccountPlatform;
  className?: string;
}

export const AddLinkedAccountButton = ({ platform, className }: AddLinkedAccountButtonProps) => {
  const linkTiktok = useLinkAccount();
  const loading = platform === TIKTOK_PLATFORM && linkTiktok.isPending();

  const handleClick = () => {
    if (platform === TIKTOK_PLATFORM) {
      void linkTiktok();
    }
  };

  return (
    <Button
      variant="solid"
      icon={<IconLinePlus size={16} className="text-kds-light-reverse" />}
      onClick={handleClick}
      className={twMerge(
        "bg-kds-dark-reverse! text-kds-light-reverse! hover:bg-(--palette-slate-11)! hover:text-kds-light-reverse!",
        className,
      )}
      loading={loading}
    >
      <Trans>Connect Account</Trans>
    </Button>
  );
};
